import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE = 'Forever Path Living™';

// Optional override for the public site origin (e.g. https://foreverpathliving.org).
// When unset, canonical/OG URLs automatically follow whatever domain serves the site,
// so switching to the custom domain later requires no code changes.
const SITE_URL = process.env.REACT_APP_SITE_URL;

export const Seo = ({ title, description }) => {
  const location = useLocation();
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Supportive Living in Virginia`;

  const origin = SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  const canonical = origin ? `${origin}${location.pathname}` : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
};

export default Seo;
